import { createRouter, createWebHashHistory } from 'vue-router'
import routes from './routes'
import dynamicRoutes from './routes/dynamicRoutes'
import { aigcStore } from '@/store/aigcStore'
import { knowStore } from '@/store/knowStore'
import { loginStore } from '@/store/loginStore'
import { localCache, sessionCache } from '@/utils/cache'
import { checkBrowser } from '@/utils/checkStatus'
import { isMobile } from '@/utils/validation'

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
for (const element of dynamicRoutes) {
  router.addRoute('index', element)
}

const closeModal = () => {
  const store = aigcStore()
  const kStore = knowStore()
  store.closeShareFolderModal()
  kStore.closeShareFolderModal()
}
const checkBrowserHandle = (to, from, next) => {
  //判断跳转到状态页
  if (!checkBrowser() && to.name !== 'pageStatus') {
    // 跳转到不支持页面
    next({
      name: 'pageStatus',
      params: {
        code: 'browserVersionLow'
      }
    })
  }
}

router.beforeEach((to, from, next) => {
  closeModal()
  //维护页面
  if (process.env.VUE_APP_API_IS_UNDER_MAINTENANCE == 'true' && to.name !== 'underMaintenance') {
    next({ name: 'underMaintenance' })
  } else {
    checkBrowserHandle(to, from, next)
    // 如果是移动端打开就跳去移动端页面
    if (isMobile() && to.meta.fixurl) {
      window.location.href = to.meta.fixurl(to)
      return
    } else if (to.name === 'shareFolder') {
      sessionCache.setCache('shareParams', to.params.code)
    } else if (to.name === 'InvitePage') {
      if (to.query.teamInviteCode) {
        localCache.setCache('invite', to.query.teamInviteCode)
        const lStore = loginStore()
        lStore.invite = to.query.teamInviteCode
      }
    } else if (to.name === 'knowledgeShareFolder') {
      sessionCache.setCache('knowledgeShareParams', to.params.code)
    }
    if (!localCache.getCache('USER') || !localCache.getCache('TOKEN')) {
      //免登录页面
      if (to.meta.noLogin) {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    } else {
      next()
    }
  }
})

export default router
